module.exports = __webpack_public_path__ + "static/media/2.7b5f17dc.jpg";